import { BankFieldSetLabel } from "client/domain/FormBuilder/BankInformation/BankConnector";
import { FormCompletion } from "client/store";
import { UserStateResponse } from "client/types";
import { BankInfoFields } from "client/utils";
import { apiClient } from "client/utils/api-client";

export type UpdateFormCompletionRequest = {
  companyInfoForm: boolean;
  storeDetailsForm: boolean;
  businessOwnerForm: boolean;
  bankForm: boolean;
};

export type BankVerificationSource = "MANUAL" | "PLAID" | "GIACT";

export type SubmitBankInfoRequest = {
  [key in Partial<BankInfoFields>]?: any;
} & {
  bankVerificationSource?: BankVerificationSource;
  canadaRoutingNumber?: string;
  bankLabel: BankFieldSetLabel;
  setBankFormComplete?: boolean;
};

export const saveFormState = (
  formCompletionData: FormCompletion
): Promise<{ formCompletedState: FormCompletion }> =>
  apiClient<{ formCompletedState: FormCompletion }>(
    "/api/update-form-completion",
    {
      data: formCompletionData,
    }
  );

export const completeBankInfoForm = (data: {
  data: SubmitBankInfoRequest;
}): Promise<UserStateResponse> =>
  apiClient<UserStateResponse>("/api/update-bank-info", {
    data,
  });
